import { type CardActivity } from '@/models/card-activity/card-activity.model'
import { type BuilderVideoType } from '@/views/NewBuilder/services/builder-videos/get-builder-videos.service'

export enum TeacherFocusBuilder {
  PROMPT = 'prompt',
  ANSWER = 'answer',
  FEEDBACK = 'feedback',
  GENERAL = 'general',
  GRADING = 'grading',
}

export interface BuilderStore {
  isSubmitting: boolean
  layout: 'grid' | 'list'
  isEditable: boolean
  teacherFocus: TeacherFocusBuilder
  isFormOpen: boolean
  isSettingsOpen: boolean
  isAIBuilderOpen: boolean
  showWarningMissingGradingCriteria: {
    isOpen: boolean
    cardId: string
  } | null
  showDialogGradingCriteria: boolean
  chatState: {
    messages: object[]
    threadId: string | null
    currentRunId: string | null
    isLoading: boolean
    isWaiting: boolean
  }
  activeScreen: 'content' | 'settings' | 'ai_assistant'
  showRubricDialog: boolean
  importModalOpen: boolean
  isMediaAreaOpen: boolean
  showBuilderVideoDialog: {
    isOpen: boolean
    type: BuilderVideoType | null
  }
  cardScores: {
    completed?: boolean
    voiceSuccess?: number
    voiceFail?: number
    transcript?: string
    words_spoken?: number
    summary?: string
    suggested_response?: string
    success?: boolean
    score?: number
    grammar_insights?: any[]
    promtSuccess?: boolean
    grading_method?: 'simple' | 'rubric'
    rubric?: any[]
    audio?: string
    actfl?: {
      justification?: string
      level?: 'NL' | 'NM' | 'NH' | 'IL' | 'IM' | 'IH' | 'AL' | 'AM' | 'AH' | 'S' | 'D'
    }
    wida?: {
      justification?: string
      level?: '1' | '2' | '3' | '4' | '5' | '6'
    }
    aiSuccess?: boolean
    attempts?: number
    correct?: number
    totalTrys?: {
      markedCorrect?: boolean
      selectedOption?: string[]
      tryAgain?: boolean
    }
  }
  cardFormData: CardActivity
}

export type UpdateChatStateBuilder = Partial<{
  threadId: string | null
  messages: object[] | []
}>
